import ComponentWithSocket from '../../../lib/component';
import { Component } from 'vue-property-decorator';

import * as Store from '../../../store';

import PhoneInput from '../../../components/phone-input/phone-input.vue';
import {
    PhoneValidation,
    PhoneValue,
} from '../../../utils/phone-validation';

@Component({
    components: { PhoneInput },
})
export default class ManageUser extends ComponentWithSocket {
    // Callback-urile WS sunt inregistrate in constructor, deci starea modificata din ele
    // trebuie sa stea in `data` (campurile de pe `this` nu ajung pe componenta reala)
    public data: {
        id: string;
        user: any;
        address: any;
        // Telefonul cu prefix; folosit doar pentru conturile care au deja prefix
        phone: PhoneValue;
        // Valoarea de la incarcare, ca sa trimitem prefixul doar daca telefonul a fost modificat
        initialPhone: PhoneValue;
        // Cont vechi pe care adminul il trece pe formatul cu prefix
        convertPhone: boolean;
        // `verified` de la incarcare: SMS-ul de cont aprobat se trimite doar la trecerea in verificat
        initialVerified: boolean;
        sendSms: boolean;
        // Rezultatul SMS-ului dupa salvare (ex. "SMS trimis.")
        smsMessage: string;
        smsSent: boolean;
    } = {
        id: '',
        user: undefined,
        address: {
            city: '',
            street: '',
            country: '',
            county: '',
        },
        phone: PhoneValidation.defaultValue(),
        initialPhone: PhoneValidation.defaultValue(),
        convertPhone: false,
        initialVerified: false,
        sendSms: true,
        smsMessage: '',
        smsSent: true,
    };

    activeTabIndex: number = 0;

    constructor() {
        super();

        this.wsListener.onGet(
            'admin.users.view',
            (success: boolean, data: any) => {
                Store.commitLoaderVisibility(this.$store, false);

                if (success) {
                    this.data.user = data;
                    this.data.phone = PhoneValidation.fromUser(data);
                    this.data.initialPhone = { ...this.data.phone };
                    this.data.convertPhone = false;
                    this.data.initialVerified = !!data.verified;
                    this.data.sendSms = true;

                    if (data.address) {
                        this.data.address = data.address;
                    }
                }
            },
        );

        this.wsListener.onPost(
            'admin.users.update',
            (success: boolean, data: any) => {
                Store.commitLoaderVisibility(this.$store, false);

                if (!success) {
                    return alert(data);
                }

                // `sms` vine doar cand contul a trecut din neverificat in verificat
                this.data.smsMessage = data && data.sms ? data.sms.message : '';
                this.data.smsSent = !(data && data.sms && !data.sms.sent);

                // Reincarcam userul ca formularul sa arate telefonul salvat (ex: dupa conversia la prefix)
                this.wsListener.sendGet('admin.users.view', {
                    _id: this.data.id,
                });
            },
        );
    }

    beforeRouteLeave(to: any, from: any, next: any) {
        this._beforeLeave(to, from);
        next();
    }

    mounted() {
        this.data.id = this.$root.$route.params.id;

        Store.commitLoaderVisibility(this.$store, true);

        this.wsListener.sendGet('admin.users.view', {
            _id: this.data.id,
        });
    }

    // Conturile vechi (fara prefix) se editeaza in formatul vechi, cu input simplu
    get hasPrefix(): boolean {
        return !!(this.data.user && this.data.user.prefix);
    }

    get showPrefixInput(): boolean {
        return this.hasPrefix || this.data.convertPhone;
    }

    // Numarul vechi e convertit in prefix + numar (07... -> +40 7..., +49... -> +49 ...)
    startPhoneConversion() {
        this.data.phone = PhoneValidation.fromUser({ phone: this.data.user.phone });
        this.data.convertPhone = true;
    }

    cancelPhoneConversion() {
        this.data.convertPhone = false;
    }

    // Adminul tocmai bifeaza Verified: la salvare userul poate primi SMS-ul de cont aprobat
    get becomingVerified(): boolean {
        return !this.data.initialVerified && !!(this.data.user && this.data.user.verified);
    }

    get phoneChanged(): boolean {
        const phone = this.data.phone;
        const initial = this.data.initialPhone;

        return (
            phone.prefix !== initial.prefix ||
            phone.phoneCountry !== initial.phoneCountry ||
            PhoneValidation.digits(phone.phone) !==
                PhoneValidation.digits(initial.phone)
        );
    }

    doUserUpdate() {
        const sendPrefixed =
            this.data.convertPhone || (this.hasPrefix && this.phoneChanged);

        if (sendPrefixed) {
            const phoneError = PhoneValidation.validate(this.data.phone);
            if (phoneError) {
                return alert(phoneError);
            }
        }

        Store.commitLoaderVisibility(this.$store, true);

        let updatedUser = this.data.user;
        updatedUser.address = this.data.address;

        this.data.smsMessage = '';

        this.wsListener.sendPost('admin.users.update', {
            ...(sendPrefixed
                ? {
                      ...updatedUser,
                      ...PhoneValidation.toPayload(this.data.phone),
                  }
                : updatedUser),
            sendSms: this.data.sendSms,
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/users/manage/index.ts